import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b45074ce&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b45074ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45074ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b45074ce')) {
      api.createRecord('b45074ce', component.options)
    } else {
      api.reload('b45074ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b45074ce&scoped=true&", function () {
      api.rerender('b45074ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PopView/index.vue"
export default component.exports